module.exports = __webpack_public_path__ + "img/wenzi@2x.8b3bad15.png";